import { useLayoutEffect, useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';

import type { RefObject } from 'react';

// Custom hook to capture the element height
export const useElementHeight = (
  targetRef: RefObject<HTMLElement | null>,
  debounceDelay = 1000
) => {
  const [elementHeight, setElementHeight] = useState(0);

  const debounced = useDebouncedCallback(
    () => {
      if (targetRef.current) {
        const newHeight = targetRef.current.offsetHeight;
        if (newHeight !== elementHeight) {
          setElementHeight(newHeight);
        }
      }
    },
    debounceDelay
  );

  useLayoutEffect(() => {
    window.addEventListener('resize', debounced);
    debounced(); // Initial height update

    return () => {
      window.removeEventListener('resize', debounced);
    };
  }, [debounced, debounceDelay]);

  return elementHeight;
};
